module.exports = __webpack_public_path__ + "img/promotions.a1f6fa2c.png";